import { HeadWrapper, MainTitle } from '~/components/misc/section-head.js';
import useTranslations from '~/components/translation/use-translations.ts';
import { useEffect } from 'react';
import { ROUTE_HUB } from '../router/constants';

/**
 * AppBooter - Native Apps needs to boot the webview though all the `Routes` are reserved in the Hybrid Router (Native Route Wrapper)
 * This `booter` (frame) is intended to bootstrap webview with the required App Bridge API without a need to use any reserved route.
 * After React view is scaffolded this component replaces the history state to a default reserved route (/global) without causing
 * any side effects. This component will not be visible to the end user, in practice this will be rendered in the background in the
 * app's view hierarchy.
 ** */

const textKeys = ['MOBILEAPP_HEADER_ABOUT'];

const AppBooter = () => {
	const { translations: tr } = useTranslations(textKeys);
	// Replace state when component mount so that placeholder app-boot won't be included in the history.
	useEffect(() => {
		window.history.replaceState({}, 'App-Boot Placeholder', ROUTE_HUB);
	}, []);
	return (
		<HeadWrapper>
			<MainTitle dataAt="section-main-title-general-global-overlay">{tr.MOBILEAPP_HEADER_ABOUT}</MainTitle>
		</HeadWrapper>
	);
};

export default AppBooter;
